//import './wdyr';

import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import store from "./store/store";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  // <RecoilRoot>
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
  // </RecoilRoot>
);
